<template>
  <pt-scan-payment :companyList="companyList" :exportLoading="exportLoading" @scanPaymentExport="scanPaymentExport" class="pt-scan-payment__withData"></pt-scan-payment>
</template>

<script>
import PtScanPayment from './index'
export default {
  name: 'pt-scan-payment__withData',
  components: {
    'pt-scan-payment': PtScanPayment
  },
  data () {
    return {
      exportLoading: false,
      companyList: []
    }
  },
  methods: {
    // 导出订金结算列表
    scanPaymentExport (val) {
      this.exportLoading = true
      val.sourceServiceTag = 'lifebank-cps'
      this.$store.dispatch('scanPaymentExport', val).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出扫码缴费失败')
      })
    },
    // 获取分子公司
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        this.companyList = newArr
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    }
  },
  created () {
    this.getCompanyList()
  }
}
</script>
